import { makeEnvironmentProviders, ENVIRONMENT_INITIALIZER, inject, importProvidersFrom } from '@angular/core';
import { provideTransloco, TranslocoConfig, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { LOCALIZATIONS } from './di';
import { Localization } from './models';

type DeepPartial<T> =
  T extends Array<any>
    ? T
    : T extends object
      ? {
          [P in keyof T]?: DeepPartial<T[P]>;
        }
      : T;
export type PartialTranslocoConfig = DeepPartial<TranslocoConfig>;

function mergeArraysToArray<T = any>(arrays: Array<Array<T>>): Array<T> {
  return [].concat.apply([], arrays as any);
}

const initializer = {
  provide: ENVIRONMENT_INITIALIZER,
  multi: true,
  useValue() {
    const service = inject(TranslocoService);
    const localizations = inject(LOCALIZATIONS, { optional: true }) as unknown as Localization[][];
    setTranslations(service, localizations);
  },
};

function setTranslations(translocoService: TranslocoService, localizations: Localization[][]) {
  const finalArr = mergeArraysToArray(localizations);
  finalArr.forEach((localization) => {
    translocoService.setTranslation({}, localization.language, {
      merge: false,
    });
  });
}

export function provideLocalization(options: {
  localizations: Localization[];
  translocoConfig: PartialTranslocoConfig;
}) {
  return makeEnvironmentProviders([
    importProvidersFrom(TranslocoPipe),
    provideTransloco({
      config: options.translocoConfig,
    }),
    {
      provide: LOCALIZATIONS,
      useValue: options.localizations,
      multi: true,
    },
    initializer,
  ]);
}

export function provideFeatureLocalization(localizations: Localization[]) {
  return [
    {
      provide: LOCALIZATIONS,
      useValue: localizations,
      multi: true,
    },
    initializer,
  ];
}
